export default {
  SET_USER(state, user) {
    state.user.id = user.id
    state.user.first_name = user.first_name
    state.user.last_name = user.last_name
    state.user.middle_name = user.middle_name
    state.user.birth_date = user.birth_date
    state.user.isRoot = user.isRoot
  },
  SET_CAN_USE_USER_ONLINE_CHECKER: (state, val) => state.canUseUserOnlineChecker = val,
  SET_CAN_CONNECT_TO_SOCKET: (state, val) => state.canConnectToSocket = val,
  SET_USER_SOCKET_CONNECTION: (state, userSocketConnection) => state.userSocketConnection = userSocketConnection,
  CLEAR_USER_SOCKET_CONNECTION(state) {
    if (state.userSocketConnection) {
      state.userSocketConnection.close()
      state.userSocketConnection = null
    }
  },
  SET_INTEGRATOR_SOCKET_CONNECTION: (state, val) => state.integratorSocketConnection = val,
  CLEAR_INTEGRATOR_SOCKET_CONNECTION(state) {
    if (state.integratorSocketConnection) {
      state.integratorSocketConnection.close()
      state.integratorSocketConnection = null
    }
  },
}
